<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-8/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
        >
          <div class="rounded-t mb-0 px-6 py-6">
            <hr class="mb-6 border-b-1 border-blueGray-300" />
            <div class="text-center mb-3">
              <h6 class="text-blueGray-500 text-md font-bold">
                {{ headingText }}
              </h6>
            </div>
            <hr class="mt-6 border-b-1 border-blueGray-300" />
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <div
              v-if="tokenStatus === 'checking'"
              class="text-blueGray-400 text-center mb-3 font-bold"
            >
              Validating your invitation link...
            </div>

            <div v-else-if="tokenStatus === 'invalid'" class="text-center">
              <span class="text-red-500 text-md">{{ invalidMessage }}</span>
              <div class="mt-6">
                <router-link
                  to="/auth/login"
                  class="text-blueGray-600 underline"
                >
                  Back to Sign In
                </router-link>
              </div>
            </div>

            <form v-else-if="inviteType === 'vendor'" @submit.prevent="submitForm">
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Company Name
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.company_name"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Company Name"
                  name="company_name"
                />
                <span
                  v-if="!formData.company_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Company Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  First Name
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.first_name"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="First Name"
                  name="first_name"
                />
                <span
                  v-if="!formData.first_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >First Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Last Name
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.last_name"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Last Name"
                  name="last_name"
                />
                <span
                  v-if="!formData.last_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Last Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Email
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.email"
                  type="email"
                  readonly
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-blueGray-100 cursor-not-allowed rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Email"
                  name="email"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Mobile
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.mobile"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Mobile"
                  name="mobile"
                />
                <span
                  v-if="!formData.mobile.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Mobile is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Phone
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.phone"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Phone"
                  name="phone"
                />
                <span
                  v-if="!formData.phone.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Phone is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Address 1
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.address_1"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Address 1"
                  name="address_1"
                />
                <span
                  v-if="!formData.address_1.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Address 1 is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Address 2
                </label>
                <input
                  v-model="formData.address_2"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Address 2"
                  name="address_2"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  City
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.city"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="City"
                  name="city"
                />
                <span
                  v-if="!formData.city.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >City is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  State
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.state"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="State"
                  name="state"
                />
                <span
                  v-if="!formData.state.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >State is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Zip Code
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.zipcode"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Zip Code"
                  name="zipcode"
                />
                <span
                  v-if="!formData.zipcode.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Zip Code is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  TIN
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.tin"
                  v-mask="'#########'"
                  type="text"
                  inputmode="numeric"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="9 digit TIN"
                  name="tin"
                />
                <span
                  v-if="!formData.tin.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >TIN is required</span
                >
                <span
                  v-else-if="formData.tin.trim() && !tinIsValid"
                  class="text-red-500 text-md"
                  >TIN must be exactly 9 digits</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Password
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.password"
                  type="password"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Password"
                  name="password"
                />
                <span
                  v-if="!formData.password.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Password is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Confirm Password
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="confirmPassword"
                  type="password"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Confirm Password"
                  name="confirm_password"
                />
                <span
                  v-if="!confirmPassword.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Confirm Password is required</span
                >
                <span
                  v-else-if="confirmPassword.trim() && !passwordsMatch"
                  class="text-red-500 text-md"
                  >Passwords do not match</span
                >
              </div>

              <div class="text-center mt-6">
                <button
                  class="bg-blueGray-800 text-white active:bg-blueGray-600 text-md font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit"
                >
                  Create Vendor Account
                </button>
              </div>
            </form>

            <form v-else-if="inviteType === 'employee'" @submit.prevent="submitForm">
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  First Name
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.first_name"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="First Name"
                  name="first_name"
                />
                <span
                  v-if="!employeeFormData.first_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >First Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Last Name
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.last_name"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Last Name"
                  name="last_name"
                />
                <span
                  v-if="!employeeFormData.last_name.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Last Name is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Email
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.email"
                  type="email"
                  readonly
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-blueGray-100 cursor-not-allowed rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Email"
                  name="email"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Contact Number
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.contact_number"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Contact Number"
                  name="contact_number"
                />
                <span
                  v-if="!employeeFormData.contact_number.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Contact Number is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Phone Number
                </label>
                <input
                  v-model="employeeFormData.phone_number"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Phone Number"
                  name="phone_number"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Gender
                  <span class="text-red-500">*</span>
                </label>
                <select
                  v-model="employeeFormData.gender"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  name="gender"
                >
                  <option value="" disabled>Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                <span
                  v-if="!employeeFormData.gender.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Gender is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Date of Birth
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.date_of_birth"
                  type="date"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  name="date_of_birth"
                />
                <span
                  v-if="!employeeFormData.date_of_birth.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Date of Birth is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  SS Number
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.ss_number"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="SS Number"
                  name="ss_number"
                />
                <span
                  v-if="!employeeFormData.ss_number.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >SS Number is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  UCI Number
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.uci_number"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="UCI Number"
                  name="uci_number"
                />
                <span
                  v-if="!employeeFormData.uci_number.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >UCI Number is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Address
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.address"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Address"
                  name="address"
                />
                <span
                  v-if="!employeeFormData.address.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Address is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  City
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.city"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="City"
                  name="city"
                />
                <span
                  v-if="!employeeFormData.city.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >City is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  State
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.state"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="State"
                  name="state"
                />
                <span
                  v-if="!employeeFormData.state.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >State is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Zip Code
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.zip_code"
                  type="text"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Zip Code"
                  name="zip_code"
                />
                <span
                  v-if="!employeeFormData.zip_code.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Zip Code is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Password
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="employeeFormData.password"
                  type="password"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Password"
                  name="password"
                />
                <span
                  v-if="!employeeFormData.password.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Password is required</span
                >
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-md font-bold mb-2"
                >
                  Confirm Password
                  <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="confirmPassword"
                  type="password"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-md shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Confirm Password"
                  name="confirm_password"
                />
                <span
                  v-if="!confirmPassword.trim() && validation_fail"
                  class="text-red-500 text-md"
                  >Confirm Password is required</span
                >
                <span
                  v-else-if="confirmPassword.trim() && employeeFormData.password !== confirmPassword"
                  class="text-red-500 text-md"
                  >Passwords do not match</span
                >
              </div>

              <div class="text-center mt-6">
                <button
                  class="bg-blueGray-800 text-white active:bg-blueGray-600 text-md font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit"
                >
                  Create Employee Account
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";

export default {
  data() {
    return {
      token: "",
      tokenStatus: "checking",
      invalidMessage: "",
      validation_fail: false,
      confirmPassword: "",
      inviteType: null,
      formData: {
        company_name: "",
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        phone: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        zipcode: "",
        tin: "",
        password: "",
      },
      employeeFormData: {
        first_name: "",
        last_name: "",
        email: "",
        contact_number: "",
        phone_number: "",
        gender: "",
        date_of_birth: "",
        ss_number: "",
        uci_number: "",
        address: "",
        city: "",
        state: "",
        zip_code: "",
        password: "",
      },
    };
  },
  computed: {
    headingText() {
      if (this.inviteType === "employee") return "EMPLOYEE REGISTRATION";
      if (this.inviteType === "vendor") return "VENDOR REGISTRATION";
      return "ACCOUNT REGISTRATION";
    },
    employeeRequiredFieldsFilled() {
      const f = this.employeeFormData;
      return (
        f.first_name.trim() !== "" &&
        f.last_name.trim() !== "" &&
        f.email.trim() !== "" &&
        f.contact_number.trim() !== "" &&
        f.gender.trim() !== "" &&
        f.date_of_birth.trim() !== "" &&
        f.ss_number.trim() !== "" &&
        f.uci_number.trim() !== "" &&
        f.address.trim() !== "" &&
        f.city.trim() !== "" &&
        f.state.trim() !== "" &&
        f.zip_code.trim() !== "" &&
        f.password.trim() !== ""
      );
    },
    employeeFormIsValid() {
      return (
        this.employeeRequiredFieldsFilled &&
        this.confirmPassword.trim() !== "" &&
        this.employeeFormData.password === this.confirmPassword
      );
    },
    tinIsValid() {
      return /^\d{9}$/.test(this.formData.tin.trim());
    },
    passwordsMatch() {
      return (
        this.formData.password.length > 0 &&
        this.formData.password === this.confirmPassword
      );
    },
    requiredFieldsFilled() {
      const f = this.formData;
      return (
        f.company_name.trim() !== "" &&
        f.first_name.trim() !== "" &&
        f.last_name.trim() !== "" &&
        f.email.trim() !== "" &&
        f.mobile.trim() !== "" &&
        f.phone.trim() !== "" &&
        f.address_1.trim() !== "" &&
        f.city.trim() !== "" &&
        f.state.trim() !== "" &&
        f.zipcode.trim() !== "" &&
        f.tin.trim() !== "" &&
        f.password.trim() !== ""
      );
    },
    formIsValid() {
      return (
        this.requiredFieldsFilled &&
        this.tinIsValid &&
        this.confirmPassword.trim() !== "" &&
        this.passwordsMatch
      );
    },
  },
  created() {
    this.token = this.$route.query.token || "";
    if (!this.token) {
      this.tokenStatus = "invalid";
      this.invalidMessage = "Invalid invitation link.";
      return;
    }
    this.validateInvitation();
  },
  methods: {
    async validateInvitation() {
      this.tokenStatus = "checking";

      try {
        const vendorResponse = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/validate_vendor_invitation`,
          { token: this.token }
        );

        if (vendorResponse.data.valid) {
          this.inviteType = "vendor";
          this.formData.email = vendorResponse.data.email || "";
          this.tokenStatus = "valid";
          return;
        }
      } catch (error) {
        // Not a vendor invitation (or vendor validation failed) — fall through and try employee.
      }

      try {
        const employeeResponse = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/validate_invitation`,
          { token: this.token }
        );

        if (employeeResponse.data.valid) {
          this.inviteType = "employee";
          this.employeeFormData.email = employeeResponse.data.email || "";
          this.tokenStatus = "valid";
          return;
        }

        this.tokenStatus = "invalid";
        this.invalidMessage =
          employeeResponse.data.message ||
          "This invitation link is invalid or has already been used.";
      } catch (error) {
        this.tokenStatus = "invalid";
        this.invalidMessage =
          error.response?.data?.message ||
          "Unable to validate this invitation link. Please try again later.";
      }
    },
    async submitForm() {
      if (this.inviteType === "employee") {
        return this.submitEmployeeForm();
      }
      return this.submitVendorForm();
    },
    async submitVendorForm() {
      if (!this.formIsValid) {
        this.validation_fail = true;
        return;
      }
      this.validation_fail = false;

      Swal.fire({
        title: "Creating your account...",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        const payload = {
          token: this.token,
          first_name: this.formData.first_name,
          last_name: this.formData.last_name,
          email: this.formData.email,
          company_name: this.formData.company_name,
          mobile: this.formData.mobile,
          phone: this.formData.phone,
          address_1: this.formData.address_1,
          address_2: this.formData.address_2,
          city: this.formData.city,
          state: this.formData.state,
          zipcode: this.formData.zipcode,
          tin: this.formData.tin,
          password: this.formData.password,
        };

        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/complete_vendor_registration`,
          payload
        );

        Swal.close();

        if (response.data.status === 200) {
          Swal.fire({
            title: "Registration completed successfully.",
            text: "Your account is pending admin activation.",
            icon: "success",
          }).then(() => {
            this.$router.push({ path: "/auth/login" });
          });
        } else {
          Swal.fire({
            title: response.data.message || "Unable to complete registration.",
            icon: "error",
          });
        }
      } catch (error) {
        Swal.close();
        let errorMsg = "An error occurred. Please try again.";
        const data = error.response?.data;
        if (data?.error) {
          errorMsg = Object.values(data.error).flat().join(" ");
        } else if (data?.errors) {
          errorMsg = Object.values(data.errors).flat().join(" ");
        } else if (data?.message) {
          errorMsg = data.message;
        } else if (error.message) {
          errorMsg = error.message;
        }
        Swal.fire({ title: errorMsg, icon: "error" });
      }
    },
    async submitEmployeeForm() {
      if (!this.employeeFormIsValid) {
        this.validation_fail = true;
        return;
      }
      this.validation_fail = false;

      Swal.fire({
        title: "Creating your account...",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        const payload = {
          invitation_token: this.token,
          first_name: this.employeeFormData.first_name,
          last_name: this.employeeFormData.last_name,
          email: this.employeeFormData.email,
          contact_number: this.employeeFormData.contact_number,
          phone_number: this.employeeFormData.phone_number,
          gender: this.employeeFormData.gender,
          date_of_birth: this.employeeFormData.date_of_birth,
          ss_number: this.employeeFormData.ss_number,
          uci_number: this.employeeFormData.uci_number,
          address: this.employeeFormData.address,
          city: this.employeeFormData.city,
          state: this.employeeFormData.state,
          zip_code: this.employeeFormData.zip_code,
          password: this.employeeFormData.password,
        };

        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/add_employee`,
          payload
        );

        Swal.close();

        if (response.data.status === 201) {
          Swal.fire({
            title: "Registration completed successfully.",
            text: "Your account is pending admin activation.",
            icon: "success",
          }).then(() => {
            this.$router.push({ path: "/auth/login" });
          });
        } else {
          Swal.fire({
            title: response.data.message || "Unable to complete registration.",
            icon: "error",
          });
        }
      } catch (error) {
        Swal.close();
        let errorMsg = "An error occurred. Please try again.";
        const data = error.response?.data;
        if (typeof data?.errors === "string") {
          errorMsg = data.errors;
        } else if (data?.errors) {
          errorMsg = Object.values(data.errors).flat().join(" ");
        } else if (data?.message) {
          errorMsg = data.message;
        } else if (error.message) {
          errorMsg = error.message;
        }
        Swal.fire({ title: errorMsg, icon: "error" });
      }
    },
  },
};
</script>
